<!--
	name: PopWin   Version: V3.0   by: coon    publish: 2022/08/11;
	include:

	功能：该组件用于实现
	可提供如下功能, 支持的形态及功能有:
		1.  窗口自动在屏幕居中
		2.  支持设置标题栏背景颜色(ctrl.captBClr)
		3.  支持设置标题颜色(ctrl.captClr)
		4.  支持设置窗口标题(ctrl.captCont)
		5.  支持设置窗口标题栏高度(ctrl.captHeight)
		6.  支持设置窗口加载的vue对象(ctrl.vuepath), 可以根据加载的vue对象, 完成不同的业务处理
	组件调用参数:
		参数名           必要性    值域          说明

	输出的值:

	外部调用方法:
		无
-->

<template>
	<div id="idWinPanel" ref="idWinPanel" style="position:absolute; left:0px; top:0px; width:100%; height:100%; border:0px solid red; display:none;">
		<div id="idPopWinPanel" ref="idPopWinPanel">
			<div id="idWinCaptPanel" ref="idWinCaptPanel" :style="{'height':ctrl.captHeight+'px'}">
				<div id="idWinCapt" ref="idWinCapt" class="DIVNoSelect" :style="{'height':ctrl.captHeight+'px','line-height':ctrl.captHeight+'px'}">{{ ctrl.captCont }}</div>
				<div id="idWinClose" ref="idWinClose" @click="onPopWinClose">╳</div>
			</div>
			<div style="flex:0 0 auto; height:5px; "></div>
			<div style="flex:1 0 auto; display:flex;">
				<div style="flex:0 0 auto; width:5px;"></div>
				<div style="flex:1 0 auto; border:0px solid blue;" id="idWinBody" ref="idWinBody">
					<router-view v-if="showWin"></router-view>
				</div>
				<div style="flex:0 0 auto; width:5px;"></div>
			</div>
			<div style="flex:0 0 auto; height:5px; "></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'PopWin',
	props:['ctrl'],
	data () {
		return {
			RouterW: 0,
			RouterH: 0,
			showWin: true,      // 用于在关闭时卸载组件
			mv_ele: null,
			mv_ml: 0,
			mv_mt: 0,
			mv_mr: 0,
			mv_mb: 0,
		}
	},
	mounted: function(){
		this.$refs["idWinCaptPanel"].onmousedown = this.popw_onmousedown;
		this.$refs["idWinCaptPanel"].onmousemove = this.popw_onmousemove;
		this.$refs["idWinCaptPanel"].onmouseup   = this.popw_onmouseup;
		this.$refs["idWinCaptPanel"].onmouseout  = this.popw_onmouseout;

		if( this.ctrl.captBClr ) this.$refs["idWinCaptPanel"].style["background"] = this.ctrl.captBClr;
		if( this.ctrl.captClr  ) this.$refs["idWinCapt"].style["color"] = this.ctrl.captClr;

		this.ctrl.self = this;
	},
	computed:{

	},
	methods:{
		onShow: function(){
			this.showWin = true;
			this.$refs["idWinPanel"].style["display"] = "block";
			this.onResize();
			this.appRoot.app.loadRouter( this.ctrl.vuepath, this.ctrl.info );
		},
		onResize: function(){
			//让窗口居中
			let w1=window.innerWidth;   //this.$parent.$el.offsetWidth;
			let h1=window.innerHeight;  //this.$parent.$el.offsetHeight;
			let w2=this.ctrl.w2; //this.$refs["idPopWinPanel"].offsetWidth;
			let h2=this.ctrl.h2; //this.$refs["idPopWinPanel"].offsetHeight;

			//console.log(w1,h1,w2,h2);
			this.$refs["idPopWinPanel"].style["width"] = (w2)+"px";
			this.$refs["idPopWinPanel"].style["height"]= (h2)+"px";
			this.$refs["idPopWinPanel"].style["margin-left"] = ((w1-w2)/2)+"px";
			this.$refs["idPopWinPanel"].style["margin-top"]  = ((h1-h2)/2)+"px";

			this.RouterW = w2-5-5;
			this.RouterH = h2-this.ctrl.captHeight-5-5;

			this.$refs["idWinBody"].style["height"] = (this.RouterH)+"px";
			this.$refs["idWinBody"].style["width"]  = (this.RouterW)+"px";
		},
		onPopWinClose: function( flag, param ){
			this.showWin = false;
			this.$refs["idWinPanel"].style["display"] = "none";
			if( flag && this.ctrl.rcallFunc ) this.ctrl.rcallFunc( param );
		},
		onPopWinClose2: function( ){
			this.showWin = false;
			this.$refs["idWinPanel"].style["display"] = "none";
		},
		/* 弹出对话框拖动相关事件 */
		popw_onmousedown: function(e){
			this.mv_ele = this.$refs["idPopWinPanel"];

			let x1=parseInt(this.mv_ele.style["margin-left"].replace(/px/g, ""));
			let y1=parseInt(this.mv_ele.style["margin-top"].replace(/px/g, ""));
			this.mv_ml = e.clientX - x1;
			this.mv_mt = e.clientY - y1;
			this.mv_mr = parseInt(this.mv_ele.style["width"].replace(/px/g, "")) - this.mv_ml;
			this.mv_mb = parseInt(this.mv_ele.style["height"].replace(/px/g, "")) - this.mv_mt;
		},
		popw_onmousemove: function(e){
			if( this.mv_ele )
			{
				this.$refs["idPopWinPanel"].style["margin-left"] = (e.clientX - this.mv_ml)+"px";
				this.$refs["idPopWinPanel"].style["margin-top"]  = (e.clientY - this.mv_mt)+"px";
			}
		},
		popw_onmouseup: function(e){
			this.mv_ele = null;
		},
		popw_onmouseout: function(e){
			this.mv_ele = null;
		},
	}
}

</script>

<style scoped>

#idPopWinPanel{ position:absolute; z-index:1000; border:0px solid #bbbbbb; box-shadow:0 0 8px rgba(0, 0, 0, .8); background:#ffffff; border-radius:9px; display:flex; flex-direction:column; }

#idWinCaptPanel{ flex:0 0 auto; display:flex; width:100%; border-radius: 9px 9px 0px 0px; background:#3596ff;}
#idWinCapt{ flex:1 0 auto; border:0px solid #ffffff; padding-left:10px; color:#ffffff; cursor:move;}
#idWinClose{ flex:0 0 auto; height:28px; width:28px; margin-right:5px; margin-top:3px; font-size:24px; border:0px solid #ffffff; text-align:center; cursor:pointer; color:#ffffff; }
#idWinClose:hover{ color:#ff3333; }

#idWinBody{ border:0px solid #bbbbbb; overflow:auto; }

</style>



// WEBPACK FOOTER //
// popwin.vue?7f024ab8